<template>
  <div>
    <HeaderComponent
      :pageContent="pageHeader"
       @change_language="handleHeaderClick"
      ></HeaderComponent> 
    <div
      class="dz-bnr-inr dz-bnr-inr-sm text-center"
      style="background-image: url(/assets/images/banner/AI.png)"
    >
      <div class="container">
        <div class="dz-bnr-inr-entry"></div>
      </div>
    </div>
    <div class="page-content">
      <section
        class="content-inner position-relative pt-0"
        style="background: white"
      >
        <div class="container">
          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <div class="card">
                <div class="card-body">
                  <div class="blog-single pt-20 sidebar dz-card">
                    <div class="dz-info m-b30">
                      <h4 class="title">
                        {{pageContent.banner_title}}
                      </h4>
                      <div class="dz-post-text">
                        <p>
                          {{pageContent.intro_paragraph}}
                        </p>
                      </div>

                      <h3 class="dz-title">{{pageContent.section1_title}}</h3>
                      <h4 class="title">
                        {{pageContent.section1_subtitle}}
                      </h4>
                      <div class="dz-post-text">
                        <ul class="m-b30">
                          <li>
                            <b>                        {{pageContent.section1_list1_b}}
                            </b> 

                            {{pageContent.section1_list1_text}}
                            
                          </li>
                          <li>
                            <b>                            {{pageContent.section1_list2_b}}
                            </b>                             {{pageContent.section1_list2_text}}
                            <br />
                            {{pageContent.section1_list2_br}}
                            
                          </li>
                        </ul>
                      </div>

                      <h4 class="title">                            {{pageContent.section2_title}}
                      </h4>
                      <div class="dz-post-text">
                        <p>
                            {{pageContent.section2_paragraph}}

                        </p>
                      </div>

                      <h4 class="title">                          {{pageContent.section3_title}}
                      </h4>
                      <div class="dz-post-text">
                        <p>
                          {{pageContent.section3_paragraph}}
                        </p>
                      </div>

                      <h4 class="title">                          {{pageContent.section4_title}}
                      </h4>
                      <div class="dz-post-text">
                        <p>
                          {{pageContent.section4_paragraph}}

                        </p>
                      </div>

                      <h4 class="title">                          {{pageContent.section5_title}}
                      </h4>
                      <div class="dz-post-text">
                        <p>
                          {{pageContent.section5_paragraph}}

                        </p>
                      </div>

                      <div class="dz-share-post">
                        <!-- <div class="post-tags">
                      <h6 class="m-b0 m-r10 d-inline">Tags:</h6>
                      <a href="javascript:void(0);"><span>Corporate</span></a>
                      <a href="javascript:void(0);"><span>Blog</span></a>
                      <a href="javascript:void(0);"><span>Marketing</span></a>
                    </div> -->
                        <div class="dz-social-icon dark">
                          <ul>
                            <li>
                              <a
                                target="_blank"
                                class="fab fa-facebook-f"
                                href="https://www.facebook.com/explore2teach/"
                              ></a>
                            </li>
                            <li>
                              <a
                                target="_blank"
                                class="fab fa-instagram"
                                href="https://www.instagram.com/explore2teach/"
                              ></a>
                            </li>
                            <li>
                              <a
                                target="_blank"
                                class="fab fa-linkedin"
                                href="https://linkedin.com/explore2teach"
                              ></a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <FooterComponent :pageContent="pageFooter"></FooterComponent>
  </div>
</template>
<script>
// @ is an alias to /src
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import globalMixins from "@/plugins/globalMixins";

export default {
  name: "Relocation",
  components: {
    HeaderComponent,
    FooterComponent,
  },
  data(){
    return {
      pageContent: [],
      pageHeader:[],
      pageFooter:[],
    }
  },mounted() {
    const storedLanguage = localStorage.getItem("language");
  if (storedLanguage) {
    this.language = storedLanguage;
  }
  this.convertLanguage();
  },
  methods: {
    goToRegister() {
      window.location = "/user/register";
    },
    scrollToSection(id) {
      const element = document.getElementById(id);
      if (element) {
        const headerOffset = 80; // Adjust this value based on your header height
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    },
    handleHeaderClick() {
      this.convertLanguage();
    },
    async convertLanguage() {
      const storedLanguage = localStorage.getItem("language");
      if (storedLanguage) {
        this.language = storedLanguage;
      }

      let lang = this.language;
      if (lang === 'us') {
        lang = 'en';
      }

      console.log("Updated content:", lang);

      const converted = globalMixins.aimatching[lang];

      const pageHeader = globalMixins.pageHeader[lang];

      const pageFooter = globalMixins.pageFooter[lang];

      if (converted) {
        this.pageContent = {
          ...this.pageContent,
          ...converted,
        };
      
        this.pageHeader={
          ...this.pageHeader,
          ...pageHeader,
        }
        this.pageFooter={
          ...this.pageFooter,
          ...pageFooter,
        }
        
      }  
    },
  },
};
</script>


 